
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as contactOxRq35C5cMQp8AXgjc9lcdM7ezmuL7Chzeacxtbt8DEMeta } from "/codebuild/output/src2924160935/src/nuxt/pages/contact.vue?macro=true";
import { default as termsDlQrklPAaVVeZHcpm_aabU8Yn1CmPWYFq91hVQ7FVT8Meta } from "/codebuild/output/src2924160935/src/nuxt/pages/terms.vue?macro=true";
import { default as indexqLDYvchLxoyTiTxFNZOdgJlKjtvBikwWAwFq9eyyuHkMeta } from "/codebuild/output/src2924160935/src/nuxt/pages/index.vue?macro=true";
export default [
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2924160935/src/nuxt/pages/contact.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/codebuild/output/src2924160935/src/nuxt/pages/terms.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2924160935/src/nuxt/pages/index.vue")
  }
]